import { useEffect, useRef, useState } from 'react'
import {
  ActionsMenuWrapper,
  BurgerLine,
  BurgerWrap,
  DropdownItem,
  DropdownPanel,
  TriggerButton,
} from './ActionsMenu.styled'

export interface ActionItem {
  label: string
  onClick: () => void
  orange?: boolean
}

interface ActionsMenuProps {
  actions: ActionItem[]
}

export const ActionsMenu = ({ actions }: ActionsMenuProps) => {
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const handleClick = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [open])

  useEffect(() => {
    if (!open) return
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('keydown', handleKey)
    return () => document.removeEventListener('keydown', handleKey)
  }, [open])

  return (
    <ActionsMenuWrapper ref={wrapperRef}>
      <TriggerButton
        $open={open}
        onClick={() => setOpen((v) => !v)}
        aria-label='Actions menu'
        aria-expanded={open}
      >
        <BurgerWrap>
          <BurgerLine $open={open} $i={0} />
          <BurgerLine $open={open} $i={1} />
          <BurgerLine $open={open} $i={2} />
        </BurgerWrap>
      </TriggerButton>

      {open && (
        <DropdownPanel>
          {actions.map((action, i) => (
            <DropdownItem
              key={action.label}
              $orange={action.orange}
              $delay={i * 50}
              onClick={() => {
                action.onClick()
                setOpen(false)
              }}
            >
              {action.label}
            </DropdownItem>
          ))}
        </DropdownPanel>
      )}
    </ActionsMenuWrapper>
  )
}
